import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "../api/axios";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../config";
import toast from "react-hot-toast";

const cookies = new Cookies();

export const useRegularizationHistory = (attendanceId, enabled = false) => {
  const getRegularizationHistory = async ({ pageParam = 0 }) => {
    let token = cookies.get(TOKEN_NAME);

    const params = {
      company_id: cookies.get(COMPANY_ID),
      product_slug: PRODUCT_SLUG,
      attendance_id: attendanceId,
      limit: 10,
      page_no: pageParam,
    };

    try {
      const response = await axios({
        method: "GET",
        url: "/attendance-regularization/list-requests-single-day",
        params: params,
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch regularization history";
      toast.error(errorMessage);
      throw error;
    }
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    status,
  } = useInfiniteQuery(
    ["regularization-history", attendanceId],
    getRegularizationHistory,
    {
      getNextPageParam: (lastPage) => {
        const currentCount = (lastPage.page_no + 1) * lastPage.per_page;
        return currentCount < lastPage.total_count ? lastPage.page_no + 1 : undefined;
      },
      enabled: enabled && !!attendanceId,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );

  const historyList = data?.pages?.flatMap((page) => page.data) || [];

  return {
    historyList,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    status,
  };
};
